import { http, httpFile } from './http_service';

//Get all
export function all(){
    return http().get('/australian-residency-status');
}
//Get all active
export function allActive(){
    return http().get('/australian-residency-status/active');
}
//Get Single
export function single(id){
    return http().get(`/australian-residency-status/${id}`);
}
//Add one
export function add(data){
    return http().post('/australian-residency-status', data)
}
//Update
export function update(id, data){
    return http().put(`/australian-residency-status/${id}`, data)
}
//Delete one
export function deleteSingle(id){
    return http().delete(`/australian-residency-status/${id}`);
}